import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children,
  isOpen,
  onClick
}) => {
  return <div className="border-b border-gray-100" data-id="element-553">
      <button className="flex justify-between items-center w-full py-4 text-left font-medium text-black" onClick={onClick} aria-expanded={isOpen} aria-controls={`accordion-content-${title.replace(/\s+/g, '-').toLowerCase()}`} data-id="element-554">
        <span data-id="element-555">{title}</span>
        <ChevronDownIcon className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-556" />
      </button>
      <div id={`accordion-content-${title.replace(/\s+/g, '-').toLowerCase()}`} className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`} aria-hidden={!isOpen} data-id="element-557">
        <div className="text-text-secondary" data-id="element-558">{children}</div>
      </div>
    </div>;
};
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}
export const Accordion: React.FC<AccordionProps> = ({
  items
}) => {
  const [openIndex, setOpenIndex] = useState(0);
  return <div className="w-full" data-id="element-559">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={index === openIndex} onClick={() => setOpenIndex(index === openIndex ? -1 : index)} data-id="element-560">
          {item.content}
        </AccordionItem>)}
    </div>;
};